import { createI18n } from 'vue-i18n';
import en from './en';
import es from './es';

const optionsIdiomas = ['en', 'es']
const fallbackLocale = 'es'

function detectIdioma() {
  const savedLocale = localStorage.getItem('user-idioma')
  if (savedLocale && optionsIdiomas.includes(savedLocale)) {
    return savedLocale
  }
  const browserLocale = navigator.language.split('-')[0]
  if (optionsIdiomas.includes(browserLocale)) {
    localStorage.setItem('user-idioma', browserLocale)
    return browserLocale
  }
  return fallbackLocale
}

const i18n = createI18n({
  locale: detectIdioma(),
  fallbackLocale,
  messages: { en: en, es: es}
})

export default i18n;